module.exports = "<div fxFlexFill fxLayoutAlign=\"center center\">\n  <mat-icon>arrow_drop_up</mat-icon>\n</div>\n"